module.exports = __webpack_public_path__ + "static/media/Chai-About.b21c9a2d.jpeg";